import * as moment from 'moment';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ReportParams } from '../../../core/shared/model/ReportParams';
import { Parent } from '../../../core/shared/model/Parent';
import { GridComponent, PageChangeEvent, RowArgs, SelectAllCheckboxState } from '@progress/kendo-angular-grid';
import { StoreInvoice } from '../../../core/shared/model/StoreInvoice';
import { SortDescriptor } from '@progress/kendo-data-query';
import { UserService } from '../../../core/services/user.service';
import { NavigationExtras, Router } from '@angular/router';
import { FSInvoiceDialogService } from '../../../core/services/fsinvoice.dialog.service';
import { InvoicesService } from '../../../core/services/invoices.service';
import { InvoiceStore } from '../../../core/shared/model/InvoiceStore';
import { StatementsService } from '../../statements/statements.service';
import { paths } from '~/app/app-paths';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';


@Component({
  selector: 'app-invoices-stores',
  templateUrl: './invoices-stores.component.html',
  styleUrls: ['./invoices-stores.component.scss']
})
export class InvoicesStoresComponent implements OnInit {

  @ViewChild(GridComponent) private invoicesStoresGrid: GridComponent;

  stores: Array<InvoiceStore> = new Array<InvoiceStore>();
  parents: Array<Parent> = new Array<Parent>();
  selectedParents: string[];
  data: any;
  fromDate: string;
  endDate: string;
  selectedRequestType: string;
  selectedInvType: string;
  selectedStores: string[];
  selectedStartDate: Date;
  selectedEndDate: Date = moment().toDate();
  reportParams: Array<ReportParams> = new Array<ReportParams>();
  selectedInvoiceStoresMap: Map<string, InvoiceStore> = new Map<string, InvoiceStore>();
  userName: string;
  selectedKeys: string[] = [];
  pageSize: number = 30;
  skip = 0;
  info = true;
  buttonCount = 5;
  type: 'numeric';
  pageSizes: number[] = [20, 40, 60];
  previousNext = true;
  selectAllState: SelectAllCheckboxState = 'unchecked';
  previousDisabled: boolean = false;
  invoices: Array<StoreInvoice>;
  sort: SortDescriptor[] = [{
    field: 'shipToSiteName',
    dir: 'asc'
  }];

  show: boolean = false;
  selectAllChecked = false;
  masterSelect = false;
  bulkSelect: boolean = false;

  //isRowSelected: boolean;
  constructor(private userService: UserService, 
              private invoiceService: InvoicesService,
              private router: Router,
              private fsInvoiceDialog: FSInvoiceDialogService, 
              private statementsservice: StatementsService, 
              public loadingIndicator: LoadingIndicatorHelper) {
  }

  get isValidSelection() {
    return this.selectedKeys.length > 0;
  }

  ngOnInit() {
    this.loadingIndicator.show();
    this.bulkSelect = false;
    this.userService.setBulkSelect(false);
    this.selectAllState = this.invoiceService.getSelectAllState();
    this.masterSelect = this.invoiceService.getMasterStoreSelect();

    this.allRowsSelected(this.selectAllState);
    this.setSelectChecked(this.selectAllState);
    this.selectedKeys = this.userService.getSelectedInvoiceStores();
    this.selectedInvoiceStoresMap = this.userService.getSelectedInvoiceStoresMap();
    this.userService.setSelectedInvoiceStores(this.selectedKeys);
    this.selectedStartDate = moment(this.userService.getSelectedStartDate()).toDate();
    this.selectedEndDate = moment(this.userService.getSelectedEndDate()).toDate();
    this.selectedInvType = this.userService.getSelectedInvType();
    this.selectedRequestType = this.userService.getSelectedRequestType();
    this.userName = this.userService.getUserName();
    this.fromDate = moment(this.selectedStartDate).format('YYYY-MM-DD');
    this.endDate = moment(this.selectedEndDate).format('YYYY-MM-DD');

    this.statementsservice.getParents(this.userName, this.selectedRequestType, this.selectedInvType, this.fromDate, this.endDate).subscribe(async (parents) => {
      this.parents = parents;
      this.selectedParents = this.parents.map(a => a.id);
      this.invoiceService.getStores(this.selectedParents).subscribe(stores => {
        this.stores = stores;
        this.userService.setStoresOriginal(stores);  // Pass storesOriginal to the service
        if (this.bulkSelect) {
          this.stores = this.stores.filter((store, index, self) =>
            index === self.findIndex((s) => s.billToSiteNumber === store.billToSiteNumber)
          );
        }
        this.loadingIndicator.hide();
      });
    });
  }

  bulkToggleChanged() {
    this.bulkSelect = !this.bulkSelect;
    this.userService.setBulkSelect(this.bulkSelect); // Update service
    if (this.bulkSelect === false) {
      this.deselectAll(); // If we turn off bulk select, reset all selections.
    }

    if (this.bulkSelect) {
      this.stores = this.stores.filter((store, index, self) =>
        index === self.findIndex((s) => s.billToSiteNumber === store.billToSiteNumber)
      );
    } else {
      this.stores = this.userService.getStoresOriginal(); // Restore original stores
    }
    this.invoicesStoresGrid.autoFitColumn(this.invoicesStoresGrid.columns.first);

  }

  backClicked() {
    this.router.navigate([paths.home]);
  }

  setSelectChecked(check: SelectAllCheckboxState) {
    if (check) {
      this.selectAllChecked = true;
    } else {
      this.selectAllChecked = false;
    }
  }

  nextClicked() {
    if (this.selectedInvoiceStoresMap.size === 0) {
      this.fsInvoiceDialog.showMessageDialog('Selection', 'You must make a selection');
    } else {
      if (this.bulkSelect) {
        let billToSiteNumbers = new Set<string>();
        this.selectedInvoiceStoresMap.forEach((x) => {
          billToSiteNumbers.add(x.billToSiteNumber);
        });
        this.userService.setSelectedInvoiceParents(Array.from(billToSiteNumbers));
      } else {
        this.userService.setSelectedInvoiceParents(this.selectedParents);
      }
      this.userService.setSelectedInvoiceStores(this.selectedKeys);
      this.router.navigate([paths.invoicesearch]);
    }
  }

  pageChange({skip, take}: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }

  isRowSelected = (e: RowArgs) => this.selectedKeys.includes(e.dataItem.shipToSiteNumber);

  selectionKey(context: RowArgs): string {
    return context.dataItem.shipToSiteNumber;
  }

  deselectAll() {
    this.selectedKeys = [];
    this.selectedInvoiceStoresMap = new Map<string, InvoiceStore>();
    this.allRowsSelected('unchecked');
  }

  allRowsSelected(selectionObj: any) {
    this.invoiceService.setSelectAllState(selectionObj)
    if (selectionObj === 'checked' || selectionObj === true) {
      this.selectAllChecked = true;
      this.selectAllState = selectionObj;
    } else if (selectionObj === 'unchecked' || selectionObj === true) {
      this.selectAllChecked = false;
      this.selectAllState = selectionObj;
    } else {
      selectionObj.deselectedRows.forEach(row => {
        this.rowCheckBoxChanged(false, row.dataItem);
      });
      selectionObj.selectedRows.forEach(row => {
        if (!this.selectedKeys.includes(row.dataItem.shipToSiteNumber)) {
          this.rowCheckBoxChanged(true, row.dataItem);
        }
      });
    }
  }

  masterClicked() {
    if (this.masterSelect === false) {
      this.masterSelect = true;
      this.stores.forEach(item => {
        // this.selectedKeys.push(item.shipToSiteNumber);
        // this.selectedInvoiceStoresMap.set(item.shipToSiteNumber, item);
        this.rowCheckBoxChanged(true, item);
      });
    } else {
      this.masterSelect = false;
      this.selectedKeys.length = 0;
      this.selectedInvoiceStoresMap.clear();
      this.stores.forEach(item => {
        this.rowCheckBoxChanged(false, item);
      });
    }
    this.invoiceService.setMasterStoreSelect(this.masterSelect);
    this.userService.setSelectedInvoiceStores(this.selectedKeys);
    this.userService.setSelectedInvoiceStoresMap(this.selectedInvoiceStoresMap);
  }

  rowCheckBoxChanged(checked: boolean, store: InvoiceStore) {
    var shipToSiteNumbers = [];
    var siteNumbers = [];
    
    if (this.bulkSelect) {
      const parentCustomerNumber = store.billToSiteNumber;
      const originalStoresUnderParent = this.userService.getStoresOriginal().filter(s => s.billToSiteNumber === parentCustomerNumber);

      shipToSiteNumbers = originalStoresUnderParent.map(s => s.shipToSiteNumber);
      siteNumbers = [...shipToSiteNumbers];
    } else {
      shipToSiteNumbers = [store.shipToSiteNumber];
      siteNumbers = [store.shipToSiteNumber];
    }

    if (checked) {
      shipToSiteNumbers.forEach((x) => this.selectedInvoiceStoresMap.set(x, store));
      siteNumbers.forEach((x) => this.selectedKeys.push(x));
    } else {
      shipToSiteNumbers.forEach((x) => this.selectedInvoiceStoresMap.delete(x));
      siteNumbers.forEach((x) => this.selectedKeys.splice(this.selectedKeys.indexOf(x), 1));
    }

  }

  finishClicked() {
    if (this.bulkSelect) {
      return;
    }
    let navigationExtras: NavigationExtras = {
      queryParams: {}
    };

    if (this.selectedInvoiceStoresMap.size == 0) {
      this.fsInvoiceDialog.showMessageDialog('Selection', 'You must make a selection');
    } else {
      this.userService.setSelectedInvoiceStores(this.selectedKeys);
      this.router.navigate([paths.invoiceinvoices], navigationExtras);
      this.userService.setSelectedInvoiceParents(this.selectedParents);
    }
  }

  onToggle(): void {
    this.show = !this.show;
  }

  close(): void {
    this.show = false;
  }

}
